import f, { forwardRef as u, useImperativeHandle as i, useState as m, useEffect as d } from "react";
import { createPortal as s } from "react-dom";
import { LeafletProvider as C } from "./context.js";
function y(t) {
  function r(e, o) {
    const { instance: n, context: a } = t(e).current;
    return i(o, () => n), e.children == null ? null : /* @__PURE__ */ f.createElement(C, {
      value: a
    }, e.children);
  }
  return /* @__PURE__ */ u(r);
}
function L(t) {
  function r(e, o) {
    const [n, a] = m(!1), { instance: c } = t(e, a).current;
    i(o, () => c), d(function() {
      n && c.update();
    }, [
      c,
      n,
      e.children
    ]);
    const l = c._contentNode;
    return l ? /* @__PURE__ */ s(e.children, l) : null;
  }
  return /* @__PURE__ */ u(r);
}
function _(t) {
  function r(e, o) {
    const { instance: n } = t(e).current;
    return i(o, () => n), null;
  }
  return /* @__PURE__ */ u(r);
}
export {
  y as createContainerComponent,
  L as createDivOverlayComponent,
  _ as createLeafComponent
};
